/* custom-cl-modal — accessible modal + right-slide-out drawer primitive.
   Markup contract:
     <button data-cl-modal-open="ID">…</button>
     <div class="cl-modal cl-modal--drawer" id="ID" data-cl-modal aria-hidden="true">
       <div class="cl-modal__scrim" data-cl-modal-close></div>
       <div class="cl-modal__panel" role="dialog" aria-modal="true" aria-label="…">
         <button class="cl-modal__x" data-cl-modal-close aria-label="Затвори">…</button>
         …content…
       </div>
     </div>
   Handles: open/close, Esc, scrim + [data-cl-modal-close], body scroll-lock, focus trap, focus restore, reduced-motion. */
(function () {
  if (window.__clModalBound) return;          // idempotency: loaded by both the PDP + ingredients-modal sections
  window.__clModalBound = true;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var openModal = null, lastFocus = null;

  /* getClientRects (not offsetParent): offsetParent is null for descendants of a position:fixed
     container, which would wrongly filter out every control inside the fixed modal. */
  function visible(el) { return !!(el.getClientRects().length || el.offsetWidth || el.offsetHeight); }
  function focusables(p) { return Array.prototype.slice.call(p.querySelectorAll(FOCUSABLE)).filter(visible); }

  function open(modal) {
    if (!modal || openModal === modal) return;
    lastFocus = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('cl-modal-lock');
    openModal = modal;
    var panel = modal.querySelector('.cl-modal__panel');
    if (panel && !panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
    function focusIn() { var f = focusables(panel)[0] || panel; try { f.focus(); } catch (e) {} }
    /* The panel animates in (visibility + translateX). A single rAF fires before it is focusable,
       so focus after paint and re-assert until focus actually lands inside the dialog. */
    window.requestAnimationFrame(function () { window.requestAnimationFrame(focusIn); });
    setTimeout(function () { if (openModal === modal && panel && !panel.contains(document.activeElement)) focusIn(); }, 80);
    setTimeout(function () { if (openModal === modal && panel && !panel.contains(document.activeElement)) focusIn(); }, 240);
  }
  function close(modal) {
    modal = modal || openModal;
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cl-modal-lock');
    openModal = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var opener = e.target.closest('[data-cl-modal-open]');
    if (opener) {
      var id = opener.getAttribute('data-cl-modal-open');
      var modal = document.getElementById(id);
      if (modal) { e.preventDefault(); open(modal); }
      return;
    }
    if (e.target.closest('[data-cl-modal-close]')) { e.preventDefault(); close(); return; }
    /* Click beside the panel closes too. Belt-and-braces for the 0×0-scrim case (2026-08-26):
       a click that lands on the open modal's flex root — outside the panel — is an outside click. */
    if (openModal && e.target.closest('[data-cl-modal]') === openModal && !e.target.closest('.cl-modal__panel')) {
      e.preventDefault(); close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openModal) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(openModal.querySelector('.cl-modal__panel'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
